import auth from '../config/firebase';
import { getCookie } from '../cookies';
import apiClient from './axiosClient';
import CreateCareerConnectionResponse from 'wwg-utilities/dist/dtos/create-career-connection.response'

const createCareerConnectionRequest = async (
  seeker: string,
  career: string,
  title: string,
  region: string,
): Promise<CreateCareerConnectionResponse> => {
  const token = (await auth.currentUser?.getIdToken()) || getCookie('token');
  return apiClient
    .post(
      `career-connections/`,
      { seeker, career, title, region },
      {
        headers: {
          'Authorization-WWG': `Bearer ${token}`,
        },
      },
    )
    .then((res) => res.data);
};

export default createCareerConnectionRequest;
